<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<div *ngIf="!loading" class="max-w-[624px] mx-auto mt-4">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        
        <!-- HEADER -->
        <div class="border-b pb-4">
            <p class="font-medium text-base text-westetics-neutral-950">
                Informações do Usuário
            </p>
            <p class="text-sm text-westetics-neutral-800 mt-2">
                Preencha os dados do novo usuário
            </p>
        </div>

        <!-- Nome do Usuário -->
        <div class="border-b pb-4 mt-4">
            <label for="name" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                Nome do Usuário*
            </label>
            <input
                type="text"
                id="name"
                formControlName="name"
                placeholder="Insira o nome do usuário"
                class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                [ngClass]="{'border-red-500': userForm.get('name')?.invalid && userForm.get('name')?.touched}"
            />
            <span class="text-red-600 text-sm" *ngIf="userForm.get('name')?.invalid && userForm.get('name')?.touched">
                Insira um nome de usuário válido.
            </span>
        </div>

        <!-- E-mail -->
        <div class="border-b pb-4 mt-4">
            <label for="email" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                E-mail*
            </label>
            <input
                type="email"
                id="email"
                formControlName="email"
                placeholder="Insira o e-mail"
                class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                [ngClass]="{'border-red-500': userForm.get('email')?.invalid && userForm.get('email')?.touched}"
            />
            <span class="text-red-600 text-sm" *ngIf="userForm.get('email')?.errors?.['required'] && userForm.get('email')?.touched">
                O e-mail é obrigatório.
            </span>
            <span class="text-red-600 text-sm" *ngIf="userForm.get('email')?.errors?.['emailTld'] && userForm.get('email')?.touched">
                Insira um e-mail válido (ex: nome@dominio.com).
            </span>
            <span class="text-red-600 text-sm" *ngIf="userForm.get('email')?.errors?.['api']">
                {{ userForm.get('email')?.errors?.['api'] }}
            </span>
        </div>

        <!-- Status -->
        <div class="border-b pb-4 mt-4">
            <p class="font-medium text-sm text-westetics-neutral-950">
                Status*
            </p>
            <div class="mt-3 flex gap-4">
                <label class="flex items-center gap-2 cursor-pointer">
                    <input
                        type="radio"
                        formControlName="is_blocked"
                        value="false"
                        class="w-4 h-4 accent-westetics-purple-800"
                    />
                    <span class="text-sm font-normal text-westetics-purple-800">Ativo</span>
                </label>
                <label class="flex items-center gap-2 cursor-pointer">
                    <input
                        type="radio"
                        formControlName="is_blocked"
                        value="true"
                        class="w-4 h-4 accent-westetics-purple-800"
                    />
                    <span class="text-sm font-normal text-westetics-purple-800">Bloqueado</span>
                </label>
            </div>
        </div>

        <!-- Permissão -->
        <div class="border-b pb-4 mt-4">
            <p class="font-medium text-sm text-westetics-neutral-950">
                Permissão*
            </p>
            <div class="mt-3 flex gap-4">
                <label class="flex items-center gap-2 cursor-pointer">
                    <input
                        type="radio"
                        formControlName="permission"
                        value="ATTENDANT"
                        class="w-4 h-4 accent-westetics-purple-800"
                    />
                    <span class="text-sm font-normal text-westetics-purple-800">Atendente</span>
                </label>
                <label class="flex items-center gap-2 cursor-pointer">
                    <input
                        type="radio"
                        formControlName="permission"
                        value="ADMIN"
                        class="w-4 h-4 accent-westetics-purple-800"
                    />
                    <span class="text-sm font-normal text-westetics-purple-800">Administrador</span>
                </label>
            </div>
            <span class="text-red-600 text-sm" *ngIf="userForm.get('permission')?.invalid && userForm.get('permission')?.touched">
                Selecione uma permissão.
            </span>

            <!-- Clínicas Vinculadas — oculto se a clínica ativa não pertence a nenhum grupo -->
            <div class="mt-4" *ngIf="userForm.get('permission')?.value === 'ATTENDANT' && activeClinicHasGroup">
                <p class="font-medium text-sm text-westetics-neutral-950">
                    Clínicas Vinculadas*
                </p>
                <p class="text-xs text-westetics-neutral-600 mt-1">
                    Selecione as clínicas que este usuário terá acesso.
                </p>
                <div class="relative mt-3">
                    <!-- Botão trigger -->
                    <button
                        type="button"
                        (click)="toggleClinicsDropdown()"
                        class="w-full flex items-center justify-between px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg text-sm text-neutral-500 text-left"
                        [ngClass]="{'border-red-500': selectedClinicIds.length === 0 && userForm.touched}"
                    >
                        <span class="truncate" *ngIf="selectedClinicIds.length === 0">Selecione as clínicas</span>
                        <span class="truncate text-westetics-neutral-950" *ngIf="selectedClinicIds.length > 0">
                            {{ selectedClinicIds.length }} clínica(s) selecionada(s)
                        </span>
                        <svg
                            class="w-4 h-4 text-neutral-400 flex-shrink-0 transition-transform duration-200"
                            [class.rotate-180]="clinicsDropdownOpen"
                            viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M9.99956 10.879L13.7121 7.1665L14.7726 8.227L9.99956 13L5.22656 8.227L6.28706 7.1665L9.99956 10.879Z" fill="#99A0AE"/>
                        </svg>
                    </button>

                    <!-- Dropdown com checkboxes + busca -->
                    <div *ngIf="clinicsDropdownOpen" class="absolute z-50 left-0 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-56 overflow-auto py-1">
                        <div class="px-3 py-2">
                            <input
                                type="text"
                                [(ngModel)]="clinicSearchTerm"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="Buscar clínica por nome ou CNPJ"
                                class="w-full px-2 py-2 border rounded text-sm outline-none focus:ring-westetics-purple-800"
                            />
                        </div>
                        <div class="divide-y">
                          <label
                              *ngFor="let clinic of filteredClinics"
                              class="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-50 text-sm"
                          >
                              <input
                                  type="checkbox"
                                  [checked]="isClinicSelected(clinic.id)"
                                  (change)="toggleClinicSelection(clinic.id)"
                                  class="w-4 h-4 accent-westetics-purple-800 rounded"
                              />
                              <span class="truncate text-westetics-neutral-800">{{ clinic.name }}</span>
                              <span class="text-xs text-neutral-400 ml-auto">{{ clinic.cnpj }}</span>
                          </label>
                          <p *ngIf="filteredClinics.length === 0" class="px-3 py-2 text-sm text-neutral-400">
                              Nenhuma clínica encontrada.
                          </p>
                        </div>
                    </div>
                </div>

                <!-- Tags das clínicas selecionadas -->
                <div *ngIf="selectedClinicIds.length > 0" class="flex flex-wrap gap-2 mt-2">
                    <span
                        *ngFor="let clinic of selectedClinicsForDefault"
                        class="inline-flex items-center gap-1 px-2 py-1 bg-westetics-purple-50 text-westetics-purple-800 rounded-md text-xs"
                    >
                        {{ clinic.name }}
                        <button type="button" (click)="toggleClinicSelection(clinic.id)" class="ml-1 hover:text-red-500">
                            <svg class="w-3 h-3" viewBox="0 0 12 12" fill="currentColor"><path d="M9.35 3.35a.5.5 0 00-.7-.7L6 5.29 3.35 2.65a.5.5 0 10-.7.7L5.29 6 2.65 8.65a.5.5 0 10.7.7L6 6.71l2.65 2.64a.5.5 0 00.7-.7L6.71 6l2.64-2.65z"/></svg>
                        </button>
                    </span>
                </div>

                <span class="text-red-600 text-sm" *ngIf="selectedClinicIds.length === 0 && userForm.touched">
                    Selecione pelo menos uma clínica.
                </span>
            </div>

            <!-- Clínica Padrão -->
            <div *ngIf="selectedClinicIds.length > 1 && userForm.get('permission')?.value === 'ATTENDANT'" class="mt-4">
                <label for="defaultClinic" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                    Clínica Padrão*
                </label>
                <p class="text-xs text-westetics-neutral-600 mb-2">
                    A clínica que será carregada automaticamente ao fazer login.
                </p>
                <select
                    id="defaultClinic"
                    [(ngModel)]="defaultClinicId"
                    [ngModelOptions]="{standalone: true}"
                    class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
                >
                    <option value="" disabled>Selecione a clínica padrão</option>
                    <option *ngFor="let clinic of selectedClinicsForDefault" [value]="clinic.id">
                        {{ clinic.name }}
                    </option>
                </select>
            </div>
        </div>

        <!-- Senha Temporária -->
        <div class="border-b pb-4 mt-4">
            <label class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                Senha Temporária
            </label>
            <p class="text-xs text-westetics-neutral-600 mb-2">
                Copie e envie esta senha ao usuário. Ele será obrigado a trocá-la no primeiro login.
            </p>
            <div class="flex gap-2">
                <input
                    type="text"
                    [value]="generatedPassword"
                    readonly
                    class="bg-gray-100 border border-gray-300 text-neutral-700 text-sm rounded-lg outline-none block w-full p-2.5 font-mono tracking-wider"
                />
                <button
                    type="button"
                    (click)="copyPassword()"
                    class="px-3 py-2.5 text-sm rounded-lg border border-westetics-purple-800 text-westetics-purple-800 hover:bg-westetics-purple-50 whitespace-nowrap flex items-center gap-1"
                >
                    <svg *ngIf="!passwordCopied" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                    </svg>
                    <svg *ngIf="passwordCopied" class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                    </svg>
                    {{ passwordCopied ? 'Copiado!' : 'Copiar' }}
                </button>
                <button
                    type="button"
                    (click)="regeneratePassword()"
                    class="px-3 py-2.5 text-sm rounded-lg border border-gray-300 text-westetics-neutral-800 hover:bg-gray-50 whitespace-nowrap flex items-center gap-1"
                >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                    </svg>
                    Gerar nova
                </button>
            </div>
        </div>



    <!-- Botões (responsivo: empilha em mobile/tablet, centralizados em desktop) -->
    <div class="flex flex-col md:flex-row md:justify-center items-center gap-3 my-6">
            <button
                type="button"
                (click)="onCancel()"
                class="w-full md:w-44 px-4 py-2 md:py-[10px] text-westetics-purple-800 rounded-lg border border-westetics-purple-800 text-sm md:text-base"
            >
                Cancelar
            </button>
            <button
                type="submit"
                class="w-full md:w-44 px-4 py-2 md:py-[10px] bg-westetics-purple-800 text-white rounded-lg text-sm md:text-base"
            >
                Criar Usuário
            </button>
        </div>
    </form>
</div>
